import React from "react";
import { motion, useReducedMotion } from "framer-motion";

/**
 * Fade/slide-in wrapper that triggers once when the element enters the viewport.
 */
export default function Reveal({
  children,
  delay = 0,
  y = 18,
  as = "div",
  once = true,
  className,
  style,
  ...rest
}) {
  const reduce = useReducedMotion();
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      style={style}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-8% 0px -8% 0px" }}
      transition={{ duration: 0.7, ease: [0.2, 0.7, 0.2, 1], delay }}
      {...rest}
    >
      {children}
    </M>
  );
}
